import { createSlice } from "@reduxjs/toolkit";

const spinnersSlice = createSlice({
	name: "spinners",
	initialState: {
		pageSpinners: [],
		buttonSpinners: [],
	},
	reducers: {
		addPageSpinner: (state, { payload }) => {
			state.pageSpinners = [...state.pageSpinners, payload];
		},
		removePageSpinner: (state, { payload }) => {
			state.pageSpinners = state.pageSpinners.filter(el => el !== payload);
		},
		addButtonSpinner: (state, { payload }) => {
			state.buttonSpinners = [...state.buttonSpinners, payload];
		},
		removeButtonSpinner: (state, { payload }) => {
			state.buttonSpinners = state.buttonSpinners.filter(el => el !== payload);
		},
	},
});

export const {
	addPageSpinner,
	removePageSpinner,
	addButtonSpinner,
	removeButtonSpinner,
	addTranslationSpinner,
	removeTranslationSpinner
} = spinnersSlice.actions;

export default spinnersSlice.reducer;
